'use strict';

/*global services*/
/*global invokeCallback*/

/*exported Notifications */
function Notifications() {
  this.modal = null;
  this.notifications = {};
  this.notificationTimeouts = {};

  this.notificationTypes = [
    'copy',
    'info',
    'save',
    'warning',
    'error',
    'print'
  ];

  this.notificationsSetting = {
    copy: {
      icon: 'glyphicon-link',
      text: '',
      timeout: 3000
    },
    info: {
      icon: 'glyphicon-info-sign',
      text: '',
      timeout: 3000
    },
    save: {
      icon: 'glyphicon-floppy-saved',
      text: '',
      timeout: 3000
    },
    warning: {
      icon: 'glyphicon-warning-sign',
      text: '',
      timeout: 3000
    },
    error: {
      icon: '',
      text: '',
      timeout: 3000
    },
    print: {
      icon: 'glyphicon-print',
      text: '',
      timeout: 5000
    }
  };

  this.$printNotification = null;

  this.init();
}

Notifications.prototype = $.extend({}, {
  constructor: 'Notifications',

  //**************************************************************************
  replaceNotificationIcon: function replaceNotificationIcon(notificationIcon) {
    if (notificationIcon) {
      if (notificationIcon.indexOf('glyphicon-') >= 0) {
        notificationIcon += ' glyphicon';
      } else if (notificationIcon.indexOf('fa-') >= 0) {
        notificationIcon += ' fa';
      }
    }

    return notificationIcon;
  },

  //**************************************************************************

  createNotification: function createNotification(type) {
    var _this = this;

    var icon = _this.notificationsSetting[type].icon;
    var text = _this.notificationsSetting[type].text;

    var notificationHTML = '<div class="page-notification page-notification--' + type + '">';
    notificationHTML +=      '<div class="page-notification__box">';
    notificationHTML +=        '<div class="page-notification__icon">';
    notificationHTML +=          '<span class="' + icon + '"></span>';
    notificationHTML +=        '</div>';
    notificationHTML +=        '<div class="page-notification__text">' + text + '</div>';
    notificationHTML +=      '</div>';
    notificationHTML +=    '</div>';

    _this.notifications[type] = $(notificationHTML);
    _this.notifications[type].hide();

    $('body').append(_this.notifications[type]);

    return _this;
  },

  viewNotification: function viewNotification(type, notificationText, notificationIcon) {
    var _this = this;

    var timeout = _this.notificationsSetting[type].timeout;

    notificationText = notificationText || _this.notificationsSetting[type].text;
    notificationIcon = notificationIcon || _this.notificationsSetting[type].icon;
    notificationIcon = _this.replaceNotificationIcon(notificationIcon);

    if (!_this.notifications[type]) {
      _this.createNotification(type);
    }

    _this.notifications[type].find('.page-notification__icon span').attr('class', notificationIcon);
    _this.notifications[type].find('.page-notification__text').text(notificationText);

    _this.notifications[type].find('.page-notification__box').removeClass('hvr-ripple-out').removeClass('autostart');
    _this.notifications[type].fadeIn('slow', function () {
      _this.notifications[type].find('.page-notification__box').addClass('hvr-ripple-out').addClass('autostart');
    });

    clearTimeout(_this.notificationTimeouts[type]);
    _this.notificationTimeouts[type] = setTimeout(function () {
      _this.notifications[type].fadeOut('slow');
    }, timeout);

    return _this;
  },

  //**************************************************************************

  viewCopyMessage: function viewCopyMessage(notificationText, notificationIcon) {
    var _this = this;

    _this.viewNotification('copy', notificationText, notificationIcon);

    return _this;
  },

  viewInfoMessage: function viewInfoMessage(notificationText, notificationIcon) {
    var _this = this;

    _this.viewNotification('info', notificationText, notificationIcon);

    return _this;
  },

  viewSaveMessage: function viewSaveMessage(notificationText, notificationIcon) {
    var _this = this;

    _this.viewNotification('save', notificationText, notificationIcon);

    return _this;
  },

  viewWarningMessage: function viewWarningMessage(notificationText, notificationIcon) {
    var _this = this;

    _this.viewNotification('warning', notificationText, notificationIcon);

    return _this;
  },

  viewErrorMessage: function viewErrorMessage(data, callback) {
    var _this = this;

    var notification = '';
    if (typeof data === 'string') {
      notification = data;
    } else {
      if (typeof data === 'object' && 'error' in data) {
        notification = data.error;
      }
    }

    if (notification) {
      _this.viewMessage(notification, callback);
    } else {
      _this.viewMessage(services.get('translator').trans('error.unknown'), callback);
    }

    return _this;
  },

  viewPrintMessage: function viewPrintMessage() {
    var _this = this;

    _this.viewNotification('print');

    return _this;
  },

  viewMessage: function (message, callback) {
    var _this = this;

    if (_this.modal) {
      _this.modal.open({
        title: services.get('translator').trans('notification.message'),
        height: 'auto',
        width: 'md',
        content: '<p class="modal-notification__message--error">' + message + '</p>',
        modalClass: 'modal-danger',
        closeCallBack: function () {
          invokeCallback(callback);
        }
      });
    } else {
      alert(message);
    }
  },

  playSuccessSound: function playSuccessSound() {
    var _this = this;

    var audio = new Audio('/sounds/success.mp3');
    audio.volume = 1;
    audio.play();

    return _this;
  },

  playWarningSound: function playWarningSound() {
    var _this = this;

    var audio = new Audio('/sounds/warning.mp3');
    audio.volume = 1;
    audio.play();

    return _this;
  },

  playErrorSound: function playErrorSound() {
    var _this = this;

    var audio = new Audio('/sounds/error.mp3');
    audio.volume = 1;
    audio.play();

    return _this;
  },

  logWarning: function logWarning(message) {
    console.warn(message);
  },

  //**************************************************************************
  init: function init() {
    var _this = this;

    if (services.has('modal-notifications')) {
      _this.modal = services.get('modal-notifications');
    }

    $.each(_this.notificationTypes, function (key, type) {
      _this.notifications[type] = null;
      _this.notificationTimeouts[type] = null;
      _this.notificationsSetting[type].text = services.get('translator').trans('notification.' + type);
    });

    return _this;
  }
});
